import React, { Component } from 'react';
import TruncateText from '../generic/TruncateText';

import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import { OverviewFooter } from 'react/card/OverviewFooter';
import TrackedAnchor from '../generic/TrackedAnchor';
import Button from 'react/views/generic/Button';
import { logFeatureUsage } from "../../../lib/analytics/AnalyticsController";

import './libraryNewsletters.less';
import LibraryNewslettersEventTypes from 'data/types/LibraryNewslettersEventTypes';

class LibraryNewslettersView extends Component {
	constructor(props) {
		super(props);


		this.handleSubscribeClick = this.handleSubscribeClick.bind(this);
	}

	renderNewsletterList() {
		return this.props.cardModel.map((newsletter, index) => {
			return (
				<TrackedAnchor key={index}
					anchorClass={"newsletter-link"}
					href={newsletter.url}
					target={"_blank"}
					featureType={LibraryNewslettersEventTypes.RECENTNEWSLETTERS_NAME_CLICKED}
					srcId={newsletter.srcId}
					destId={newsletter.title}>
					<TruncateText line={2} truncateText="..." text={newsletter.title} />
				</TrackedAnchor>
			);
		});
	}

	getFirstResult() {
		let firstResult = {};
		if (this.props.cardModel && this.props.cardModel.length >= 0) {
			firstResult = this.props.cardModel[0];
		}

		return firstResult;
	}

	handleSubscribeClick() {
		let srcId = this.getFirstResult().srcId;
		logFeatureUsage(LibraryNewslettersEventTypes.RECENTNEWSLETTERS_SIGNUP_CLICKED, srcId , "Sign Up For Newsletters");

		if (this.props.onClick) {
			this.props.onClick();
		}
	}

	renderSubscribe() {
		const libraryNewsletterText = "Sign up for newsletters";
		let firstResult = this.getFirstResult();

		return (
			<Button
				onClick={this.handleSubscribeClick}
				href={firstResult.optInLink}
				target="_blank"
				rel="noreferrer noopener">
				{libraryNewsletterText}
			</Button>
		);
	}

	render() {
		return (
			<div>
				<Card>
					<CardTitle title="Library Newsletters" />
					<div className='newsletter-content'>
						{this.renderSubscribe()}
						<span className="newsletter-card-text">Recent issues:</span>
						{this.renderNewsletterList()}
					</div>
					<OverviewFooter />
				</Card>
			</div>
		);
	}
}

export default LibraryNewslettersView;



// WEBPACK FOOTER //
// ./src/react/views/librarynewsletters/LibraryNewslettersView.jsx